export default {
  subproyectos: [],
  table_headers: [
    { title: 'CÓDIGO', sortKey: 'id' },
    { title: 'DESCRIPCION', sortKey: 'descripcion' },
    { title: 'PROYECTO', sortKey: 'idProyecto' },
    { title: 'ACTIVO', sortKey: 'isActive' },
    { title: 'UNIDAD DE NEGOCIO', sortKey: 'id_business_unit' },
    { title: 'ACCIONES', sortKey: 'actions' },
  ],
  idSubproyectoModificado: null
}
